import { DashboardModule } from '@domain-group/suit-theme'

import type { TaskListModel } from '@models/taskList'

import Conversation from '@components/Conversation'
import { requestOptions } from '@components/EntityActivity'

interface ProjectNotesProps {
  taskList: TaskListModel,
}

const ProjectNotes = (props: ProjectNotesProps) => {
  const { taskList: { id, title } } = props

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column', padding: 'large' }} title="Project Notes">
      <Conversation
        boxProps={{ marginTop: 0 }}
        requestOptions={requestOptions.conversation}
        showAddCommentBox={false}
        subjectId={id}
        subjectType="TaskList"
        title={`Project for ${title}`}
      />
    </DashboardModule>
  )
}

export default ProjectNotes
